import { FC, useState } from "react";
import { AnimatePresence } from "framer-motion";

import {
  ProductionScenePropResource,
  ProductionSceneResource,
} from "@/types/resources";
import {
  InfoBlock,
  InfoHeadline,
  PlusButton,
} from "./ProductionScriptBlockInfo";
import PropsModal from "./PropsModal";
import Text from "@/components/Text";

interface Props {
  props?: ProductionScenePropResource[][];
  scene: ProductionSceneResource;
  sceneNumber: number;
}

const SidebarProps: FC<Props> = ({ props, scene, sceneNumber }) => {
  const [showModal, setShowModal] = useState(false);

  const sceneProps = props?.[sceneNumber - 1];

  return (
    <>
      <InfoHeadline
        $type="smallBold"
        as="button"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <PlusButton>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.75 0.749023C3.75 0.33481 3.41421 -0.000976562 3 -0.000976562C2.58579 -0.000976562 2.25 0.33481 2.25 0.749023V2.25098H0.749023C0.33481 2.25098 -0.000976562 2.58676 -0.000976562 3.00098C-0.000976562 3.41519 0.33481 3.75098 0.749023 3.75098H2.25V5.25095C2.25 5.66516 2.58579 6.00095 3 6.00095C3.41421 6.00095 3.75 5.66516 3.75 5.25095V3.75098H5.25095C5.66516 3.75098 6.00095 3.41519 6.00095 3.00098C6.00095 2.58676 5.66516 2.25098 5.25095 2.25098H3.75V0.749023Z"
              fill="currentColor"
            />
          </svg>
        </PlusButton>
        Props
      </InfoHeadline>
      {!!sceneProps?.length ? (
        sceneProps.map((prop) => (
          <InfoBlock key={prop.id}>
            <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 13.7334V16.9334"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.3274 13.0877C15.1575 12.2691 14.6729 11.5491 13.977 11.0814C13.9126 11.037 13.8586 10.9791 13.8191 10.9117C13.7796 10.8444 13.7554 10.7692 13.7482 10.6915L13.0305 3.54764C13.0173 3.41603 12.9554 3.29402 12.8569 3.20527C12.7584 3.11653 12.6303 3.06738 12.4975 3.06738H6.50278C6.36993 3.06738 6.24182 3.11653 6.14331 3.20527C6.04481 3.29402 5.98294 3.41603 5.96972 3.54764L5.25199 10.6915C5.24484 10.7692 5.22064 10.8444 5.18111 10.9117C5.14158 10.9791 5.08767 11.037 5.0232 11.0814C4.32733 11.5491 3.84272 12.2691 3.67286 13.0877C3.65626 13.1655 3.6573 13.246 3.67589 13.3234C3.69449 13.4008 3.73018 13.4731 3.78037 13.535C3.83056 13.5969 3.89398 13.6469 3.96602 13.6813C4.03805 13.7158 4.1169 13.7338 4.19681 13.734H14.8034C14.8833 13.7338 14.9622 13.7158 15.0342 13.6813C15.1063 13.6469 15.1697 13.5969 15.2199 13.535C15.27 13.4731 15.3057 13.4008 15.3243 13.3234C15.3429 13.246 15.344 13.1655 15.3274 13.0877Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <Text $type="smallBold" $color="black">
              {prop.title}
            </Text>
          </InfoBlock>
        ))
      ) : (
        <InfoBlock>
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 13.7334V16.9334"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.3274 13.0877C15.1575 12.2691 14.6729 11.5491 13.977 11.0814C13.9126 11.037 13.8586 10.9791 13.8191 10.9117C13.7796 10.8444 13.7554 10.7692 13.7482 10.6915L13.0305 3.54764C13.0173 3.41603 12.9554 3.29402 12.8569 3.20527C12.7584 3.11653 12.6303 3.06738 12.4975 3.06738H6.50278C6.36993 3.06738 6.24182 3.11653 6.14331 3.20527C6.04481 3.29402 5.98294 3.41603 5.96972 3.54764L5.25199 10.6915C5.24484 10.7692 5.22064 10.8444 5.18111 10.9117C5.14158 10.9791 5.08767 11.037 5.0232 11.0814C4.32733 11.5491 3.84272 12.2691 3.67286 13.0877C3.65626 13.1655 3.6573 13.246 3.67589 13.3234C3.69449 13.4008 3.73018 13.4731 3.78037 13.535C3.83056 13.5969 3.89398 13.6469 3.96602 13.6813C4.03805 13.7158 4.1169 13.7338 4.19681 13.734H14.8034C14.8833 13.7338 14.9622 13.7158 15.0342 13.6813C15.1063 13.6469 15.1697 13.5969 15.2199 13.535C15.27 13.4731 15.3057 13.4008 15.3243 13.3234C15.3429 13.246 15.344 13.1655 15.3274 13.0877Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Text $type="smallBold" $color="gray">
            No props added
          </Text>
        </InfoBlock>
      )}
      <AnimatePresence>
        {!!showModal && (
          <PropsModal scene={scene} onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarProps;
